module.exports = {"130626100":"定兴镇","130626101":"固城镇","130626102":"贤寓镇","130626103":"北河镇","130626104":"天宫寺镇","130626105":"小朱庄镇","130626106":"姚村镇","130626107":"杨村镇","130626200":"东落堡乡","130626201":"高里乡","130626202":"张家庄乡","130626204":"肖村乡","130626205":"柳卓乡","130626207":"北田乡","130626208":"北南蔡乡","130626209":"李郁庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130626.json
// module id = 246
// module chunks = 0